<template>

    <div class="app-email-w">
        <div class="app-email-i">
            <div class="ae-side-menu">
                <div class="aem-head">
                    <a class="ae-side-menu-toggler">
                        <i class="os-icon os-icon-hamburger-menu-2"></i>
                    </a>
                </div>
                <ul class="ae-main-menu">
                    <li :class="{'active': tab == selectedTab }" v-for="tab in tabOptions">
                        <a @click="switchTab(tab)">
                            <i class="fal fa-cog"></i>
                            <span>{{tab}}</span>
                        </a>
                    </li>
                </ul>
            </div>

            <CopyHeaderTab v-if="selectedTab=='Copy Headers'" />
            <ImageNamingTab v-if="selectedTab=='Image Sequence'" />
            <UserTab v-if="selectedTab=='Users'" />
            <CompletionTab v-if="selectedTab=='Completion Rules'" />
            <StyleGuideTab v-if="selectedTab=='Style Guides'" />

        </div>
    </div>

</template>

<script>
import EmptyState from '@/components/common/EmptyState'
import Loader from '@/components/common/EmptyState'
import SessionTabs from '@/components/common/SessionView/SessionTabs'

import CopyHeaderTab from '@/components/orgdesk/settings/CopyHeader'
import ImageNamingTab from '@/components/orgdesk/settings/ImageNaming'
import UserTab from '@/components/orgdesk/settings/User'
import CompletionTab from '@/components/orgdesk/settings/CompletionRule'
import StyleGuideTab from '@/components/orgdesk/settings/StyleGuide'

export default {
  components: {
    EmptyState,
    Loader,
    SessionTabs,
    CopyHeaderTab,
    ImageNamingTab,
    UserTab,
    CompletionTab,
    StyleGuideTab
  },
  data () {
    return {
      tabOptions: [
        'Users',
        'Copy Headers',
        'Image Sequence',
        'Completion Rules',
        'Style Guides'
      ],
      selectedTab: 'Copy Headers'
    }
  },
  methods: {
    switchTab (tab) {
      this.selectedTab = tab
    }
  }
}
</script>

<style scoped>
.ae-side-menu {
  height: calc(100vh - 54px);
}
.app-email-i {
  height: calc(100vh - 54px);
  flex: 1;
}
.ae-side-menu {
  flex: 0 0 200px;
}
</style>
